
 <!---------------Abort screen ---------->
 <div class="abort-screen__mainWrapper">
    <h3>{{'abortScreenPage.abortTitle' | translate}}</h3>
    <button (click)="continueDepost()" class="site-btn__primary site-btn--lg">{{'abortScreenPage.continueButton' | translate}}</button>
    <h5 (click)="closeDepositFlow()">{{'abortScreenPage.cancelButton' | translate}}</h5>
</div>
<!---------------Abort screen ---------->